import { formatPhoneNumber } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import { AddressDetailLabelValue, DetailLabelValuePair } from '@strata/react-label-value-pairs';

import { PrescriberDetails as PrescriberDetailsInterface } from 'store/reference/referenceSlice';

interface PrescriberDetailsProps {
    prescriberInfo?: PrescriberDetailsInterface;
}

export const PrescriberDetails = ({ prescriberInfo = undefined }: PrescriberDetailsProps) => (
    <FormSectionWithRows
        sectionTitle="Prescriber Details"
        isLoading={!prescriberInfo}
        rowOneContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Name"
                    value={prescriberInfo?.name}
                />
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Phone"
                    value={formatPhoneNumber(prescriberInfo?.telephoneNumber)}
                />
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Fax"
                    value={formatPhoneNumber(prescriberInfo?.faxNumber)}
                />
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Prescriber NPI"
                    value={prescriberInfo?.prescriberNpi}
                />
            </>
        }
        rowTwoContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Practice"
                    value={prescriberInfo?.organizationName}
                />
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Practice NPI"
                    value={prescriberInfo?.practiceNpi}
                />
                <AddressDetailLabelValue
                    style={{ width: '25%' }}
                    label="Practice Address"
                    address1={prescriberInfo?.address1}
                    address2={prescriberInfo?.address2}
                    city={prescriberInfo?.city}
                    state={prescriberInfo?.state}
                    zip={prescriberInfo?.postalCode}
                />
            </>
        }
    />
);
